/**
 * Export `appRoutes`.
 */

export const appRoutes = {
  home: '/',
  dashboard: {
    base: '/dashboard',
    home: {
      base: '/dashboard/home'
    },
    medical: {
      base: '/dashboard/medical',
      drugs: '/dashboard/medical/drugs',
      drugsEdit: '/dashboard/medical/drugs/:id/edit',
      missingDrugs: '/dashboard/medical/missing-drugs',
      missingDrugsDetail: '/dashboard/medical/missing-drugs/:code/detail',
      missingDrugsConvert: '/dashboard/medical/missing-drugs/:code/convert',
      ccisCodes: '/dashboard/medical/ccis-codes',
      ccisCodesEdit: '/dashboard/medical/ccis-codes/:cci/edit',
      ccisDrugs: '/dashboard/medical/ccis-drugs',
      ccis: '/dashboard/medical/ccis',
      ccisEdit: '/dashboard/medical/ccis/:id/edit'
    },
    users: {
      detail: {
        medications: '/dashboard/users/:userId/medications',
        definedAlarms: '/dashboard/users/:userId/defined-alarms',
        devices: '/dashboard/users/:userId/devices',
        base: '/dashboard/users/:userId/detail',
        usersEdit: '/dashboard/users/:userId/detail/edit',
        biometricData: '/dashboard/users/:userId/biometric-data',
        settings: '/dashboard/users/:userId/settings',
        settingsEdit: '/dashboard/users/:userId/settings/:settingId',
        authorizations: '/dashboard/users/:userId/authorizations',
        pushTokens: '/dashboard/users/:userId/push-tokens',
        pinNumbers: '/dashboard/users/:userId/pin-numbers',
        sales: '/dashboard/users/:userId/sales',
        salesDetail: '/dashboard/users/:userId/sales/:id',
        salesAdd: '/dashboard/users/:userId/sales/create',
        saleEdit: '/dashboard/users/:userId/sales/:id/edit',
        devTools: '/dashboard/users/:userId/dev-tools',
        therapySyncDetail: '/dashboard/users/:userId/dev-tools/therapy-sync/:id'
      },
      base: '/dashboard/users',
      users: '/dashboard/users/users',
      metrics: '/dashboard/users/metrics'
    },
    services: {
      orders: '/dashboard/services/orders',
      orderDetail: '/dashboard/services/orders/:id',
      sales: '/dashboard/services/sales',
      salesDetail: '/dashboard/services/sales/:id',
      pharmacyPlans: '/dashboard/services/pharmacy-plans',
      campaigns: '/dashboard/services/campaigns',
      pharmacies: {
        base: '/dashboard/services/pharmacies',
        userStats: '/dashboard/services/pharmacies/user-stats',
        plan: '/dashboard/services/pharmacies/:pharmacyId/plan',
        ledger: '/dashboard/services/pharmacies/:pharmacyId/ledger',
        campaigns: '/dashboard/services/pharmacies/:pharmacyId/campaigns',
        consents: '/dashboard/services/pharmacies/:pharmacyId/consents',
        consentsEdit: '/dashboard/services/pharmacies/:pharmacyId/consents/:phoneNumber/edit',
        integrations: '/dashboard/services/pharmacies/:pharmacyId/integrations',
        integrationsEdit: '/dashboard/services/pharmacies/:pharmacyId/integrations/:integrationId/edit',
        sharedAccesses: '/dashboard/services/pharmacies/:pharmacyId/shared-accesses'
      },
      pharmaciesEdit: '/dashboard/services/pharmacies/:id/edit',
      subscriptionsList: '/dashboard/services',
      subscriptionsEdit: '/dashboard/services/:id/edit',
      subscriptionsDetail: {
        users: '/dashboard/services/:subscriptionId/users',
        usersEdit: '/dashboard/services/:subscriptionId/users/:pharmacyId/:userId/edit',
        pharmacies: {
          base: '/dashboard/services/:subscriptionId/pharmacies',
          baseEdit: '/dashboard/services/:subscriptionId/pharmacies/:pharmacyId/:userId/edit',
          consents: '/dashboard/services/:subscriptionId/pharmacies/:pharmacyId/consents',
          consentsEdit: '/dashboard/services/:subscriptionId/pharmacies/:pharmacyId/consents/:phoneNumber/edit',
          integrations: '/dashboard/services/:subscriptionId/pharmacies/:pharmacyId/integrations',
          integrationsEdit:
            '/dashboard/services/:subscriptionId/pharmacies/:pharmacyId/integrations/:integrationId/edit'
        }
      }
    },
    tables: {
      base: '/dashboard/tables',
      dialCodes: '/dashboard/tables/dial-codes',
      dialCodesEdit: '/dashboard/tables/dial-codes/:id',
      devices: '/dashboard/tables/devices'
    },
    support: {
      base: '/dashboard/support',
      openTickets: '/dashboard/support/open-tickets',
      openTicketById: '/dashboard/support/open-tickets/:id'
    },
    settings: {
      base: '/dashboard/settings',
      general: '/dashboard/settings',
      profile: '/dashboard/settings/profile',
      languages: '/dashboard/settings/languages',
      languagesEdit: '/dashboard/settings/languages/:code',
      config: '/dashboard/settings/config',
      configEdit: '/dashboard/settings/config/:id/edit'
    },
    developer: {
      base: '/dashboard/developer',
      logs: '/dashboard/developer/logs',
      logsTherapy: '/dashboard/developer/logs-therapy',
      ignoreUrlLogs: '/dashboard/developer/ignore-url-logs',
      translations: '/dashboard/developer/translations',
      missingTranslations: '/dashboard/developer/missing-translations',
      smsTest: '/dashboard/developer/sms-test'
    }
  }
};
